var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "picking-modal",
      attrs: { role: "presentation" },
      on: {
        mousedown: function ($event) {
          if ($event.target !== $event.currentTarget) {
            return null
          }
          return _vm.$emit("close")
        },
      },
    },
    [
      _c(
        "section",
        {
          staticClass: "picking-dialog picking-dialog--completed",
          attrs: {
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": "completed-title",
          },
        },
        [
          _c("header", { staticClass: "picking-dialog__header" }, [
            _c("div", [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "picking-completed__title" },
                [
                  _c("h2", { attrs: { id: "completed-title" } }, [
                    _vm._v("Picklijst " + _vm._s(_vm.picking.code)),
                  ]),
                  _vm._v(" "),
                  _c("router-link", { attrs: { to: _vm.picking.detailPath } }, [
                    _vm._v("Detailpagina"),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "p",
                [
                  _c("i", { staticClass: "ak-icon" }, [_vm._v("receipt_long")]),
                  _vm._v("\n                    Bestelling: "),
                  _c("router-link", { attrs: { to: _vm.picking.detailPath } }, [
                    _vm._v(_vm._s(_vm.picking.orderCode)),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _vm.picking.externalOrderId
                ? _c("p", [
                    _c("i", { staticClass: "ak-icon" }, [
                      _vm._v("confirmation_number"),
                    ]),
                    _vm._v(
                      " Extern ordernummer: " +
                        _vm._s(_vm.picking.externalOrderId)
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("p", [
                _c("i", { staticClass: "ak-icon" }, [_vm._v("person_outline")]),
                _vm._v(" " + _vm._s(_vm.picking.customerName)),
              ]),
              _vm._v(" "),
              _c("p", [
                _c("i", { staticClass: "ak-icon" }, [_vm._v("near_me")]),
                _vm._v(
                  " " + _vm._s(_vm.picking.address) + "\n                    "
                ),
                _vm.picking.hasSuspiciousShippingAddress
                  ? _c(
                      "i",
                      {
                        staticClass: "ak-icon picking-dialog__address-warning",
                        attrs: {
                          title:
                            "Controleer het leveringsadres: straatnaam en huisnummer lijken verwisseld of dubbel ingevuld.",
                          "aria-label":
                            "Controleer het leveringsadres: straatnaam en huisnummer lijken verwisseld of dubbel ingevuld.",
                        },
                      },
                      [_vm._v("warning")]
                    )
                  : _vm._e(),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "picking-dialog__close",
                attrs: { type: "button", "aria-label": "Sluiten" },
                on: {
                  click: function ($event) {
                    return _vm.$emit("close")
                  },
                },
              },
              [_c("i", { staticClass: "ak-icon" }, [_vm._v("close")])]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "picking-completed__body" }, [
            _c("dl", { staticClass: "picking-completed__picker" }, [
              _c("dt", [_vm._v("Naam orderpicker")]),
              _vm._v(" "),
              _c("dd", [_vm._v(_vm._s(_vm.picking.pickerName))]),
            ]),
            _vm._v(" "),
            _vm.picking.remarks
              ? _c(
                  "section",
                  {
                    staticClass:
                      "picking-completed__section picking-completed__section--first",
                  },
                  [
                    _c("h3", [_vm._v("Interne opmerkingen picking")]),
                    _vm._v(" "),
                    _c("p", { staticClass: "picking-completed__remarks" }, [
                      _vm._v(_vm._s(_vm.picking.remarks)),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.selectedItems.length
              ? _c(
                  "section",
                  {
                    staticClass: "picking-completed__section",
                    class: {
                      "picking-completed__section--first": !_vm.picking.remarks,
                    },
                  },
                  [
                    _c("h3", [_vm._v("Bestelling")]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "picking-completed__items" },
                      _vm._l(_vm.selectedItems, function (item) {
                        return _c("div", { key: item.id }, [
                          _c("span", [
                            _vm._v(_vm._s(item.title) + " "),
                            _c("small", [_vm._v("#" + _vm._s(item.code))]),
                          ]),
                          _vm._v(" "),
                          _c("strong", [
                            _vm._v(
                              _vm._s(item.picked) + "/" + _vm._s(item.requested)
                            ),
                          ]),
                        ])
                      }),
                      0
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.selectedMaterials.length
              ? _c("section", { staticClass: "picking-completed__section" }, [
                  _c("h3", [_vm._v("Verpakking")]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "picking-completed__summary" },
                    _vm._l(_vm.selectedMaterials, function (material) {
                      return _c("div", { key: material.id }, [
                        _c("span", [_vm._v(_vm._s(material.title))]),
                        _vm._v(" "),
                        _c("strong", [_vm._v(_vm._s(material.amount))]),
                      ])
                    }),
                    0
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.hasDelivery
              ? _c("section", { staticClass: "picking-completed__section" }, [
                  _c("h3", [_vm._v("Verzending")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "picking-completed__summary" }, [
                    _vm.picking.shipping.numberOfBoxes
                      ? _c("div", [
                          _c("span", [_vm._v("Bpost-labels")]),
                          _vm._v(" "),
                          _c("strong", [
                            _vm._v(_vm._s(_vm.picking.shipping.numberOfBoxes)),
                          ]),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.picking.shipping.numberOfBoxes
                      ? _c("div", [
                          _c("span", [_vm._v("Bpost-pakkettype")]),
                          _vm._v(" "),
                          _c("strong", [
                            _vm._v(_vm._s(_vm.picking.shipping.boxType)),
                          ]),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.picking.shipping.numberOfBoxes
                      ? _c("div", [
                          _c("span", [_vm._v("Totaal gewicht verzending")]),
                          _vm._v(" "),
                          _c("strong", [
                            _vm._v(_vm._s(_vm.totalWeight) + " kg"),
                          ]),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.picking.shipping.boxType ===
                    _vm.picking.shipping.otherDelivery
                      ? _c("div", [
                          _c("span", [_vm._v("Levering")]),
                          _vm._v(" "),
                          _c("strong", [_vm._v("Ander")]),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.picking.shipping.numberOfEnvelopes
                      ? _c("div", [
                          _c("span", [_vm._v("Enveloppen te frankeren")]),
                          _vm._v(" "),
                          _c("strong", [
                            _vm._v(
                              _vm._s(_vm.picking.shipping.numberOfEnvelopes)
                            ),
                          ]),
                        ])
                      : _vm._e(),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.error
              ? _c(
                  "p",
                  {
                    staticClass: "picking-dialog__error",
                    attrs: { role: "alert" },
                  },
                  [_vm._v(_vm._s(_vm.error))]
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("footer", { staticClass: "picking-completed__footer" }, [
            _c("div", { staticClass: "picking-completed__documents" }, [
              _c(
                "button",
                {
                  attrs: {
                    type: "button",
                    disabled: _vm.printing === "picking-list",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("print", "picking-list")
                    },
                  },
                },
                [
                  _c("i", { staticClass: "ak-icon" }, [_vm._v("print")]),
                  _vm._v(" Picklijst"),
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  attrs: {
                    type: "button",
                    disabled: _vm.printing === "shipping-list",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("print", "shipping-list")
                    },
                  },
                },
                [
                  _c("i", { staticClass: "ak-icon" }, [_vm._v("print")]),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.hasShipping ? "Leverbon" : "Leverbon & afronden"
                      )
                  ),
                ]
              ),
              _vm._v(" "),
              _vm.hasShipping
                ? _c(
                    "button",
                    {
                      attrs: {
                        type: "button",
                        disabled: _vm.printing === "shipping-label",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("print", "shipping-label")
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "ak-icon" }, [_vm._v("print")]),
                      _vm._v(" Verzendlabel"),
                    ]
                  )
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass:
                  "picking-button picking-button--primary picking-completed__new",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.$emit("new")
                  },
                },
              },
              [_vm._v("\n                Nieuwe picking\n            ")]
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "picking-completed__status" }, [
      _c("i", { staticClass: "ak-icon" }, [_vm._v("check")]),
      _vm._v(" Opgeslagen"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }